import {actionMap} from '../reducers/index'
import {fetchApi} from "shared/actions/fetchApi"
import handleError from 'shared/errorHandler/actions/handleError'
import * as types from './types'


export default () => dispatch => {
    dispatch({type: types.GET_CSRF_START})
    return fetchApi('/api/as/auth/csrf-token')
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_CSRF_SUCCESS, response: response
            })
        })
        .catch(error => {
            dispatch({
                type: types.GET_CSRF_FAILURE
            })
            dispatch(handleError({
                message: error.message,
                title: "Error occurred while trying to establish connection to authentication service"
            }))
        })
}

export const handler_GET_CSRF_START = (reduxState) => {
    return ({
        ...reduxState,
        CSRF: undefined
    })
}

export const handler_GET_CSRF_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        CSRF: action.response.csrfToken
    })
}

export const handler_GET_CSRF_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        CSRF: undefined
    })
}

actionMap[types.GET_CSRF_START] = handler_GET_CSRF_START
actionMap[types.GET_CSRF_SUCCESS] = handler_GET_CSRF_SUCCESS
actionMap[types.GET_CSRF_FAILURE] = handler_GET_CSRF_FAILURE


// WEBPACK FOOTER //
// ./src/screens/login/actions/getCsrfToken.js